module.exports = __webpack_public_path__ + "static/media/MithunSuvarna.57750474.svg";